export default "__VITE_ASSET__Cm2sh7dC__"